'use strict';

(function (window, document) {
  window.addEventListener('DOMContentLoaded', function() {
    menu();
    nossosNumeros();
    animacoes();
    formularioContato();
  });

  const menu = () => {
    try {
      const navBar = document.querySelector('nav.navbar');
      const navLinks = document.querySelectorAll('.nav-item');
      const menu = document.getElementById('main-nav');
      const togglerBtn = document.querySelector('button.navbar-toggler');
      let bsCollapse;
      navLinks.forEach((l) => {
        l.addEventListener('click', () => {
          if (togglerBtn.clientHeight > 0) {
            bsCollapse = bsCollapse || new bootstrap.Collapse(menu);
            bsCollapse.toggle();
          }
        });
      });
      togglerBtn.addEventListener('click', () => navBar.classList.toggle('navbar--open'));
    } catch {}
  };

  const formularioContato = () => {
    try {
      const form = document.getElementById('form-contato');
      form.addEventListener('submit',function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          const toast = new window.bootstrap.Toast(document.getElementById('form-response-error'));
          toast.show();
        } else {
          form.querySelectorAll('.form-control').readonly = true;
          form.querySelector('button[type="submit"]').disabled = true;
          form.querySelector('button[type="submit"]').innerText = 'Enviando...';
        }
        form.classList.add('was-validated');
      }, false);
    } catch {}
  };

  const isInViewport = (element) => {
    if (!element) {
      return;
    }
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const nossosNumeros = () => {
    try {
      const numerosFirstLI = document.querySelector('#numbers .numbers__content li:first-child');
      if (!numerosFirstLI) {
        return;
      }
      const animate = (obj, initVal, lastVal, duration, decimals) => {
        let startTime = null;
        decimals = isNaN(decimals) ? 0 : decimals;

        const step = (currentTime) => {
          if (!startTime) {
            startTime = currentTime;
          }
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const value = progress * (lastVal - initVal) + initVal;
          if (decimals) {
            obj.innerHTML = value.toFixed(decimals).replace('.', ',');
          } else {
            obj.innerHTML = Math.floor(value);
          }
          if (progress < 1) {
            window.requestAnimationFrame(step);
          }
        };
        window.requestAnimationFrame(step);
      };

      const counters = document.querySelectorAll('.count');

      const init = () => {
        counters.forEach((counter) => {
          const initVal = parseFloat(counter.innerText);
          const lastVal = parseFloat(counter.getAttribute('data-target'));
          const decimals = parseInt(counter.getAttribute('data-decimals'));
          const duration = counter.hasAttribute('data-duration')
            ? parseInt(counter.getAttribute('data-duration'))
            : 3000;
          animate(counter, initVal, lastVal, duration, decimals);
        });
      };

      const scrollEvent = () => {
        if (isInViewport(numerosFirstLI)) {
          window.removeEventListener('scroll', scrollEvent);
          init();
        }
      };
      window.addEventListener('scroll', scrollEvent);
      const event = new Event('scroll', {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      window.dispatchEvent(event);
    } catch {}
  };

  const animacoes = () => {
    const scrollEvent = () => {
      const elements = document.querySelectorAll('.animate__animated');
      elements.forEach((element) => {
        if (isInViewport(element)) {
          const animation = element.getAttribute('data-fx');
          element.classList.add(`animate__${animation}`);
          element.style.opacity = 1;
        }
      });
    };
    window.addEventListener('scroll', scrollEvent);
    scrollEvent();
  };
})(window, window.document);
